export const getMedsSuggestions = state => state.autoComplete.suggestions;
export const getMedsSearchText = state => state.searchText;
